export const Loading = () => {
  return (
    <>
      <style>{`
        @keyframes tw-spin {
          from { transform: rotate(0deg); }
          to   { transform: rotate(360deg); }
        }
        @keyframes tw-spin-reverse {
          from { transform: rotate(0deg); }
          to   { transform: rotate(-360deg); }
        }
        @keyframes tw-breathe {
          0%, 100% { transform: scale(1);   opacity: 1; }
          50%       { transform: scale(1.06); opacity: 0.92; }
        }
        @keyframes tw-dot {
          0%, 80%, 100% { transform: scale(0.6); opacity: 0.3; }
          40%           { transform: scale(1);   opacity: 1; }
        }
        @keyframes tw-fade-in {
          from { opacity: 0; transform: translateY(12px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .tw-auth-loader {
          position: fixed;
          inset: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background: #ffffff;
          z-index: 9999;
          font-family: 'Roboto', 'Segoe UI', sans-serif;
          animation: tw-fade-in 0.4s ease both;
        }
        .tw-logo-ring-wrap {
          position: relative;
          width: 120px;
          height: 120px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 32px;
        }
        /* Outer ring — fast spin */
        .tw-ring-outer {
          position: absolute;
          inset: 0;
          border-radius: 50%;
          border: 3px solid transparent;
          border-top-color: #0f63c7;
          border-right-color: #0f63c740;
          animation: tw-spin 1.1s linear infinite;
        }
        /* Inner ring — slower reverse spin */
        .tw-ring-inner {
          position: absolute;
          inset: 10px;
          border-radius: 50%;
          border: 2px solid transparent;
          border-bottom-color: #0452bd;
          border-left-color:  #0452bd40;
          animation: tw-spin-reverse 1.7s linear infinite;
        }
        /* Logo pill */
        .tw-logo-pill {
          position: relative;
          width: 80px;
          height: 80px;
          border-radius: 50%;
          background: white;
          box-shadow: 0 4px 24px rgba(4, 82, 189, 0.18), 0 1px 4px rgba(4,82,189,0.1);
          display: flex;
          align-items: center;
          justify-content: center;
          animation: tw-breathe 2.4s ease-in-out infinite;
        }
        .tw-logo-pill svg {
          width: 52px;
          height: 52px;
        }
        /* Text area */
        .tw-auth-label {
          font-size: 15px;
          font-weight: 500;
          color: #334155;
          letter-spacing: 0.01em;
          margin-bottom: 6px;
        }
        .tw-auth-sub {
          font-size: 12px;
          color: #94a3b8;
          margin-bottom: 20px;
        }
        /* Three-dot wave */
        .tw-dots {
          display: flex;
          gap: 6px;
          align-items: center;
        }
        .tw-dot {
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background: #0f63c7;
          animation: tw-dot 1.4s ease-in-out infinite;
        }
        .tw-dot:nth-child(2) { animation-delay: 0.2s; }
        .tw-dot:nth-child(3) { animation-delay: 0.4s; }
      `}</style>

      <div className="tw-auth-loader">
        <div className="tw-logo-ring-wrap">
          <div className="tw-ring-outer" />
          <div className="tw-ring-inner" />
          <div className="tw-logo-pill">
            {/* Logo inline para evitar parpadeo de carga de imagen */}
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 657 659" role="img" aria-label="TeamWork">
              <defs>
                <linearGradient id="tw-grad" x1="114" y1="62" x2="515" y2="606" gradientUnits="userSpaceOnUse">
                  <stop offset="0" stopColor="#0f63c7"/>
                  <stop offset="1" stopColor="#0452bd"/>
                </linearGradient>
                <clipPath id="tw-clip">
                  <circle cx="326" cy="329" r="318"/>
                </clipPath>
              </defs>
              <circle cx="326" cy="329" r="318" fill="url(#tw-grad)"/>
              <g fill="#fff" clipPath="url(#tw-clip)">
                <circle cx="235.5" cy="215.5" r="69.5"/>
                <circle cx="417.5" cy="215.5" r="69.5"/>
                <path fillRule="evenodd" d="M126 649V443c0-65 48-117 110-117 39 0 73 17 90 44 18-27 52-44 91-44 62 0 110 52 110 117v206h-78V442c0-25-18-43-41-43s-41 18-41 43v207h-81V442c0-25-18-43-41-43s-41 18-41 43v207z"/>
              </g>
            </svg>
          </div>
        </div>

        <p className="tw-auth-label">Autenticando</p>
        <p className="tw-auth-sub">Verificando tu identidad&hellip;</p>

        <div className="tw-dots">
          <span className="tw-dot" />
          <span className="tw-dot" />
          <span className="tw-dot" />
        </div>
      </div>
    </>
  );
};
